module.exports = __webpack_public_path__ + "static/media/background-follo.d4ea3321.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/advertisers/assets/images/background-follo.jpg
// module id = ./src/advertisers/assets/images/background-follo.jpg
// module chunks = 8